"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCpZone = exports.normalizer = void 0;
const utils_fetch_1 = __importDefault(require("@gcloud-npm/utils.fetch"));
const utils_monitoring_sonda_1 = __importDefault(require("@gcloud-npm/utils.monitoring.sonda"));
const utils_monitoring_get_uuid_1 = __importDefault(require("@gcloud-npm/utils.monitoring.get-uuid"));
const node_build_process_build_environments_1 = __importDefault(require("@gcloud-npm/node.build-process.build-environments"));
const processName = "ADABYRON-API";
const familyApi = "geo";
const normalizer = (response) => {
    let res = {};
    if (response && response.data && response.data.zone) {
        res.zone = response.data && response.data.zone;
    }
    return res;
};
exports.normalizer = normalizer;
function getCpZone({ context, cp = "", build = false }) {
    const idRequest = (0, utils_monitoring_get_uuid_1.default)();
    let sonda = null;
    if (!build) {
        // importo sonda
        sonda = new utils_monitoring_sonda_1.default({
            eventName: "GEO.GET_CP_ZONE",
            context,
            uniqueId: idRequest,
            origin: processName,
        });
    }
    const { geo: connectionData } = context.environment;
    const { endpoint: host } = connectionData;
    let URL_API = `${host}/api/movistar-layer/address/v1/zone/get`;
    if (cp) {
        URL_API = `${URL_API}?postalCode=${cp}`;
    }
    const headers = (0, node_build_process_build_environments_1.default)(build, familyApi, context);
    const request = new utils_fetch_1.default({
        method: "GET",
        endpoint: URL_API,
        data: null,
        headers,
        sonda,
    });
    return request.makeRequest();
}
exports.getCpZone = getCpZone;
exports.default = getCpZone;
//# sourceMappingURL=index.js.map